export default __webpack_public_path__ + "static/media/ELEMENTOS_15.d59c80f9.png";